const indexItems = [
  { letter: 'A', label: '动作片', count: '850+', desc: '拳拳到肉的硬核格斗与极限追车' },
  { letter: 'B', label: '喜剧片', count: '620+', desc: '让你捧腹大笑的欢乐时光' },
  { letter: 'C', label: '科幻片', count: '480+', desc: '探索宇宙与未来的无限想象' },
  { letter: 'D', label: '爱情片', count: '550+', desc: '浪漫动人的爱情故事' },
  { letter: 'E', label: '恐怖片', count: '390+', desc: '让你心跳加速的惊悚体验' },
  { letter: 'F', label: '动画片', count: '420+', desc: '全家共享的奇幻动画世界' },
  { letter: 'G', label: '纪录片', count: '310+', desc: '真实世界的深度探索' },
  { letter: 'H', label: '悬疑片', count: '360+', desc: '烧脑反转的智力较量' },
  { letter: 'I', label: '战争片', count: '280+', desc: '宏大战场的历史回响' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full mb-4">
            影片索引
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            影片索引
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            按类型快速浏览8848影院全片库，从动作到战争，总有一类是你的菜
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {indexItems.map((item, idx) => (
            <div
              key={idx}
              className="group flex items-start gap-4 p-5 rounded-xl bg-background-200/60 border border-background-300/40 cursor-pointer transition-all duration-300 hover:border-accent-500/25 hover:bg-background-200/90"
            >
              <div className="flex-shrink-0 w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl bg-accent-500/10 text-accent-400 font-bold font-heading text-lg md:text-xl">
                {item.letter}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <h3 className="text-sm md:text-base font-semibold text-foreground-200">{item.label}</h3>
                  <span className="text-xs text-primary-400 bg-primary-500/10 px-1.5 py-0.5 rounded">
                    {item.count}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 flex items-center mt-1 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <i className="ri-arrow-right-s-line text-foreground-400"></i>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}